import React, {useState} from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";


export default function ConfirmDialog({title, content, onClose}) {
    const [open, setOpen] = useState(true);

    const handleClose = (valid) => {
        setOpen(false);

        onClose(valid);
    };

    return (
        open && (<React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose(false)} variant="outlined" color="primary">Annuler</Button>
                    <Button onClick={() => handleClose(true)} autoFocus variant="contained"
                            color="primary">Valider</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>)
    );
}